import L from "../../atoms/icon/icon.vue.js";
import I from "../../atoms/icon/icon-frame.vue.js";
import w from "./select-box-list/select-box-list.vue.js";
import { resolveComponent as o, openBlock as u, createElementBlock as m, createElementVNode as n, toDisplayString as p, createBlock as k, withCtx as B, createVNode as c, normalizeClass as h, createCommentVNode as f, withDirectives as V, withModifiers as b, withKeys as x, vModelText as C, vShow as D } from "vue";
/* empty css                       */
import A from "../../_virtual/_plugin-vue_export-helper.js";
import O from "../../utils/mixins/theme/theme.vue.js";
import P from "../../utils/mixins/uid/uid.vue.js";
const _ = { category: "interface", name: "search" }, y = (e, t, l) => {
  var r;
  const a = Array.isArray(e) ? e == null ? void 0 : e[0] : e;
  return (r = t.find((i) => i.value === a)) == null ? void 0 : r[l];
}, S = {
  name: "DsSelectBoxSearch",
  components: { DsIcon: L, DsIconFrame: I, DsSelectBoxList: w },
  mixins: [O, P],
  props: {
    options: {
      type: Array,
      required: !0
    },
    labels: {
      type: Object,
      required: !0
    },
    placeholder: {
      type: String,
      required: !0
    },
    opened: {
      type: Boolean,
      required: !0
    },
    focusIndex: {
      type: Number,
      required: !0
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    value: {
      type: [String, Array],
      default: null
    },
    icon: {
      type: Object,
      default: null
    },
    maxLength: {
      type: Number,
      required: !0
    },
    showPlaceholder: {
      type: Boolean,
      default: !0
    }
  },
  data: () => ({
    internalValue: "",
    inputValue: "",
    showClearButton: !1,
    internalPlaceholderValue: ""
  }),
  computed: {
    internalValueLength() {
      return Array.isArray(this.internalValue) ? this.internalValue.length : null;
    },
    computedIcon() {
      const e = this.showPlaceholder ? this.icon || _ : null;
      if (this.internalValue && this.internalValue.length) {
        const t = y(this.internalValue, this.options, "icon");
        return this.internalValueLength > 1 || !t ? e : t;
      }
      return e;
    },
    computedOptions() {
      let e = [], t = [];
      return this.multiple ? e = this.options.map((l) => {
        var a;
        return { selected: !!((a = this.internalValue) != null && a.includes(l.value)), ...l };
      }).sort((l, a) => a.selected - l.selected) : this.internalValue && !this.multiple ? e = [
        { id: "", text: this.placeholder, value: "", ...this.icon && { icon: this.icon } },
        ...this.options
      ] : e = this.options, this.inputValue && (t = e.filter((l) => l.text.toLowerCase().replace(/\s/g, "").includes(this.inputValue.toLowerCase().replace(/\s/g, "")))), t.length ? t : e;
    },
    ariaLiveLabel() {
      return this.opened ? `${this.computedOptions.length} ${this.labels.results}` : this.value ? this.value : "";
    },
    ariaActiveDescendant() {
      return this.focusIndex > 0 ? `${this.uidLabel}-select-box-list-${this.focusIndex}` : null;
    },
    isActive() {
      return Array.isArray(this.internalValue) ? this.internalValue.length !== 0 : !!this.internalValue;
    },
    uidLabel() {
      return this.uuid("select-box-s");
    }
  },
  watch: {
    value(e) {
      e != null && this.value !== "" && (this.internalValue = e);
    }
  },
  created() {
    this.value !== void 0 && this.value !== null && this.value !== "" ? (this.internalValue = this.value, this.setPlaceholderValue()) : (this.internalValue = this.multiple ? [] : "", this.internalPlaceholderValue = this.showPlaceholder ? this.placeholder : "");
  },
  methods: {
    open() {
      var t, l;
      const e = this.multiple ? this.computedOptions.filter((a) => a.selected).map((a) => a.text).join(",") : (l = (t = this.computedOptions.filter((a) => a.value === this.internalValue)) == null ? void 0 : t[0]) == null ? void 0 : l.text;
      this.opened || (this.$emit("open"), this.$emit("dropdown-opened", { label: e }));
    },
    clearValue(e) {
      const t = this.multiple ? [] : "";
      this.internalValue = t, this.showClearButton = !1, this.$emit("value", t), (e == null ? void 0 : e.label) === "cross-circle-fill" && this.$emit("selection-cleared", e), this.$nextTick(() => {
        this.setPlaceholderValue();
      });
    },
    clearInputValue() {
      this.inputValue = "";
    },
    handleFocus() {
      this.$emit("focus"), this.open();
    },
    handleInput(e) {
      const t = e.target.value;
      this.inputValue = t.replace(/[^a-zA-Z_ +/?]+/, "");
    },
    submitValue(e) {
      var t;
      if (!(this.internalValue === void 0 || this.internalValue === null)) {
        if (this.multiple) {
          const l = (t = this.internalValue) == null ? void 0 : t.findIndex((a) => a === e.value);
          l !== -1 ? (this.internalValue.splice(l, 1), this.$emit("selected-item-removed", e)) : (this.internalValue.push(e.value), this.$emit("selected-item-clicked", e));
        } else
          this.internalValue = e.value, this.$emit("selected-item-clicked", e), this.$emit("close");
        this.$emit("value", this.internalValue), this.$nextTick(() => {
          this.inputValue = "", this.setPlaceholderValue();
        });
      }
    },
    setPlaceholderValue() {
      const e = () => {
        const t = y(this.internalValue, this.options, "text");
        return this.internalValueLength > 1 ? `${this.internalValueLength} ${this.labels.results}` : t;
      };
      this.internalValue && this.internalValue.length ? (this.internalPlaceholderValue = e(), this.showClearButton = !0) : (this.internalPlaceholderValue = this.showPlaceholder ? this.placeholder : "", this.showClearButton = !1);
    },
    handleClickOutside() {
      this.$nextTick(() => {
        var e, t;
        if (this.setPlaceholderValue(), this.opened) {
          const l = this.multiple ? this.computedOptions.filter((a) => a.selected).map((a) => a.text).join(",") : (t = (e = this.computedOptions.filter((a) => a.value === this.internalValue)) == null ? void 0 : e[0]) == null ? void 0 : t.text;
          this.$emit("dropdown-closed", { label: l });
        }
      });
    }
  }
}, $ = { class: "ds-select-box-search" }, F = {
  "aria-live": "assertive",
  role: "status",
  "aria-atomic": "true",
  class: "ds-screen-reader-visible"
}, q = { class: "ds-field-layout" }, N = ["aria-activedescendant", "aria-expanded", "aria-describedby", "aria-controls", "maxlength", "placeholder"], T = ["aria-label"], j = ["id"];
function z(e, t, l, a, r, i) {
  const d = o("DsIcon"), g = o("DsIconFrame"), v = o("DsSelectBoxList");
  return u(), m("div", $, [
    n("div", F, p(i.ariaLiveLabel), 1),
    n("div", q, [
      i.computedIcon ? (u(), k(g, {
        key: 0,
        size: "48",
        "align-y": "center",
        "align-x": "center"
      }, {
        default: B(() => [
          c(d, {
            class: h(e.theme === "light" ? "ds-color-black" : "ds-color-white"),
            category: i.computedIcon.category,
            name: i.computedIcon.name
          }, null, 8, ["class", "category", "name"])
        ]),
        _: 1
      })) : f("", !0),
      V(n("input", {
        "onUpdate:modelValue": t[0] || (t[0] = (s) => e.inputValue = s),
        "aria-activedescendant": i.ariaActiveDescendant,
        "aria-expanded": l.opened.toString(),
        "aria-describedby": `${i.uidLabel}-select-box-search-hint`,
        "aria-controls": `${i.uidLabel}-select-box-search-list`,
        "aria-autocomplete": "both",
        name: "select-box-search-input",
        role: "combobox",
        autocomplete: "off",
        maxlength: l.maxLength,
        class: h(["ds-field ds-select-box-search__field", [{ "ds-field--active": i.isActive }, `ds-field--${e.theme}`, `ds-select-box-search__field--${e.theme}`]]),
        placeholder: e.internalPlaceholderValue,
        onInput: t[1] || (t[1] = (...s) => i.handleInput && i.handleInput(...s)),
        onClick: t[2] || (t[2] = b((...s) => i.open && i.open(...s), ["prevent"])),
        onFocus: t[3] || (t[3] = (...s) => i.handleFocus && i.handleFocus(...s)),
        onKeydown: [
          t[4] || (t[4] = x((s) => e.$emit("close"), ["tab"])),
          t[5] || (t[5] = x(b((...s) => i.clearInputValue && i.clearInputValue(...s), ["prevent"]), ["escape"]))
        ]
      }, null, 42, N), [
        [
          C,
          e.inputValue,
          void 0,
          { trim: !0 }
        ]
      ]),
      V(n("button", {
        type: "button",
        "aria-label": l.labels.clearValueButton,
        class: h(["ds-button-link-icon ds-select-box-search__button", e.theme === "light" ? "ds-button-link-icon--black" : "ds-button-link-icon--green"]),
        onClick: t[6] || (t[6] = (s) => i.clearValue({ label: "cross-circle-fill" }))
      }, [
        c(d, {
          class: "ds-select-box-search__button__icon",
          category: "interface",
          name: "cross-circle-fill"
        })
      ], 10, T), [
        [D, e.showClearButton]
      ])
    ]),
    c(v, {
      id: `${i.uidLabel}-select-box-search-list`,
      theme: e.theme,
      opened: l.opened,
      options: i.computedOptions,
      onClose: t[7] || (t[7] = (s) => e.$emit("close")),
      onSelect: i.submitValue
    }, null, 8, ["id", "theme", "opened", "options", "onSelect"]),
    l.labels.ariaLabelHint ? (u(), m("span", {
      key: 0,
      id: `${i.uidLabel}-select-box-search-hint`,
      class: "ds-hidden"
    }, p(l.labels.ariaLabelHint), 9, j)) : f("", !0)
  ]);
}
const Q = /* @__PURE__ */ A(S, [["render", z]]);
export {
  Q as default
};
